import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQCategory = ({ category, searchQuery }) => {
  const [expandedQuestions, setExpandedQuestions] = useState({});

  const toggleQuestion = (questionId) => {
    setExpandedQuestions(prev => ({
      ...prev,
      [questionId]: !prev?.[questionId]
    }));
  };

  // Highlight search terms in text
  const highlightText = (text, query) => {
    if (!query?.trim()) return text;

    const parts = text?.split(new RegExp(`(${query})`, 'gi'));
    return parts?.map((part, index) => 
      part?.toLowerCase() === query?.toLowerCase() ? (
        <mark key={index} className="bg-yellow-200 dark:bg-yellow-800 px-1 rounded">
          {part}
        </mark>
      ) : (
        part
      )
    );
  };

  return (
    <div className="bg-card rounded-lg shadow-warm-md overflow-hidden">
      {/* Category Header */}
      <div className="p-4 border-b border-border">
        <div className="flex items-center gap-3">
          <div
            className="w-10 h-10 rounded-lg flex items-center justify-center"
            style={{ backgroundColor: `${category?.color}20` }}
          >
            <Icon name={category?.icon} size={20} style={{ color: category?.color }} />
          </div>
          <div>
            <h2 className="text-h4 font-heading text-foreground">{category?.title}</h2>
            <p className="text-sm text-muted-foreground">
              {category?.questions?.length} question{category?.questions?.length !== 1 ? 's' : ''}
            </p>
          </div>
        </div>
      </div>

      {/* Questions List */}
      <div className="divide-y divide-border">
        {category?.questions?.map((question) => (
          <div key={question?.id} className="bg-card">
            {/* Question Header */}
            <button
              onClick={() => toggleQuestion(question?.id)}
              className="w-full p-4 flex items-center justify-between hover:bg-primary/5 transition-colors text-left"
            >
              <div className="flex-1 pr-4">
                <h3 className="font-semibold text-foreground">
                  {highlightText(question?.question, searchQuery)}
                </h3>
              </div>
              <Icon
                name={expandedQuestions?.[question?.id] ? 'chevron-up' : 'chevron-down'}
                size={20}
                className="text-muted-foreground flex-shrink-0"
              />
            </button>

            {/* Answer Content */}
            {expandedQuestions?.[question?.id] && (
              <div className="px-4 pb-4 pt-0">
                <div className="pl-4 border-l-2 border-primary/30">
                  <p className="text-muted-foreground leading-relaxed">
                    {highlightText(question?.answer, searchQuery)}
                  </p>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQCategory;